import React from 'react';
import { FaGithub, FaInstagram, FaYoutube, FaFacebook, FaTwitter, FaLinkedin, FaTwitch } from 'react-icons/fa';
import './SocialMedia.css';

const iconMap = {
  github: FaGithub,
  instagram: FaInstagram,
  youtube: FaYoutube,
  facebook: FaFacebook,
  twitter: FaTwitter,
  linkedin: FaLinkedin,
  twitch: FaTwitch,
};

const SocialMedia = ({ socialsMedia = [] }) => (
  <section id="redes">
    <h2 className="section-heading">redes sociales</h2>
    <div className="social-icons">
      {socialsMedia.map((social, i) => {
        const Icon = iconMap[social.icono];
        return Icon ? (
          <a key={i} href={social.url} target="_blank" rel="noreferrer" className="social-link" aria-label={social.icono}>
            <Icon />
          </a>
        ) : null;
      })}
    </div>
  </section>
);

export default SocialMedia;
